import { get } from 'common/api';
import { CLIENT_ID } from '../../../constants';

export const getAppVersions = params =>
  get(
    `/v5/app_versions?kind=major&device=web&client_id=${CLIENT_ID}&after=${
      params.currentVersion
    }`
  );
